import { RouteInterface } from "../interfaces/RouteInterface";
import {Login} from "../features/public/Login/Login";
import {RouteDefine} from "./RouteDefine";
import Setup from "../features/public/Setup";
import ResetPassword from "../features/public/ResetPassword/ResetPassword";
import ForgotPassword from "../features/public/ResetPassword/ForgotPassword";
import { Register } from "../features/public/Register/Register";
import { Config } from "../features/public/Config/Config";

export const authRoutes : Array<RouteInterface> = [
    { path: '/login', Component: Login },
    { path: RouteDefine.setup, Component: Setup },
    {path: '/reset-password', Component: ResetPassword},
    {path: '/forgot-password', Component: ForgotPassword},
    {path: '/register', Component: Register},
    // {path: '/config', Component: Config},

]
